import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { NewModalModule } from 'outshared-lib';
import { BicycleCoverageInfoModule } from '../bicycle-coverage-info';
import { CarCoverageInfoModule } from '../car-coverage-info';
import { CaravanCoverageInfoModule } from '../caravan-coverage-info';
import { MopedCoverageInfoModule } from '../moped-coverage-info';
import { MotorCoverageInfoModule } from '../motor-coverage-info';
import { BaseCoverageInfoModalComponent } from './base-coverage-info-modal.component';

/** @deprecated - this is moved to libs/shared/feature-coverage-modals */
@NgModule({
    imports: [
        CommonModule,
        ListModule,
        NewModalModule,

        // modal content
        BicycleCoverageInfoModule,
        CarCoverageInfoModule,
        CaravanCoverageInfoModule,
        MopedCoverageInfoModule,
        MotorCoverageInfoModule,
    ],
    declarations: [
        BaseCoverageInfoModalComponent,
    ],
    exports: [
        BaseCoverageInfoModalComponent,
    ],
})
export class BaseCoverageInfoModalModule {}
